import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import useStore from '../store/storeContext';

const publicRoutes: Readonly<Array<string>> = ['/', '/preview'];

function AuthenticatedRoute() {
    const { user } = useStore();

    const isLoggedIn = user.isUserLoggedIn;
    const location = useLocation();

    const isAuthenticatedOrPublicRoute = () => {
        const isAuthenticated = isLoggedIn;
        const isPublicRoute =
            publicRoutes.includes(location.pathname) ||
            location.pathname.includes('/index.html/account/activateandreset/') ||
            location.pathname.includes('/index.html/forgot/password/') ||
            location.pathname.includes('/index.html/document/share/') ||
            location.pathname.includes('/preview/');
        return isAuthenticated || isPublicRoute;
    };

    return <>{!isAuthenticatedOrPublicRoute() && <Navigate to={'/'} replace={true} />}</>;
}

export default observer(AuthenticatedRoute);
